module.exports = __webpack_public_path__ + "media/bells.5e780460.mp4";